<!-- This document is organised in blocks seperated by <div> inside each block is a bit of code
  to make the styleguide itself look good. Generally everthing that is important is in the "blockcontent"
  <div> block -->

<!-- Guide for used icons -->
<div class="block">
    <button
        mat-raised-button
        (click)="iconsVisible.set(!iconsVisible())"
    >
        @if (iconsVisible()) {
        <mat-icon>expand_less</mat-icon>
        } @else {
        <mat-icon>expand_more</mat-icon>
        }
        Icons
    </button>
    @if (iconsVisible()) {
    <div class="blockcontent">
        <br />Über das Icon hovern, um den Namen zu bekommen<br />
        <mat-icon matTooltip="delete">delete</mat-icon>
        <mat-icon matTooltip="menu">menu</mat-icon>
        <mat-icon matTooltip="face">face</mat-icon>
        <mat-icon matTooltip="add">add</mat-icon>
        <mat-icon matTooltip="visibility">visibility</mat-icon>
        <mat-icon matTooltip="visibility_off">visibility_off</mat-icon>
        <mat-icon matTooltip="lock_reset">lock_reset</mat-icon>
        <mat-icon matTooltip="draw">draw</mat-icon>
        <mat-icon matTooltip="content_copy">content_copy</mat-icon>
        <mat-icon matTooltip="close">close</mat-icon>
        <mat-icon matTooltip="ink_pen">ink_pen</mat-icon>
        <mat-icon matTooltip="add_photo_alternate">add_photo_alternate</mat-icon>
        <mat-icon matTooltip="music_note">music_note</mat-icon>
        <mat-icon matTooltip="search">search</mat-icon>
        <mat-icon matTooltip="expand_less">expand_less</mat-icon>
        <mat-icon matTooltip="expand_more">expand_more</mat-icon>
        <mat-icon matTooltip="add_shopping_cart">add_shopping_cart</mat-icon>
        <mat-icon matTooltip="settings">settings</mat-icon>
        <mat-icon matTooltip="dashboard">dashboard</mat-icon>
        <mat-icon matTooltip="category">category</mat-icon>
        <mat-icon matTooltip="web_asset">web_asset</mat-icon>
        <mat-icon matTooltip="group">group</mat-icon>
        <mat-icon matTooltip="work">work</mat-icon>
        <mat-icon matTooltip="stock_media">stock_media</mat-icon>
        <mat-icon matTooltip="bigtop_updates">bigtop_updates</mat-icon>
        <mat-icon matTooltip="code">code</mat-icon>
        <mat-icon matTooltip="open_in_new">open_in_new</mat-icon>
        <mat-icon matTooltip="golf_course">golf_course</mat-icon>
        <mat-icon matTooltip="cruelty_free">cruelty_free</mat-icon>
        <mat-icon matTooltip="directions_walk">directions_walk</mat-icon>
        <mat-icon matTooltip="snowshoeing">snowshoeing</mat-icon>
        <mat-icon matTooltip="sports_gymnastics">sports_gymnastics</mat-icon>
        <mat-icon matTooltip="cast_for_education">cast_for_education</mat-icon>
        <mat-icon matTooltip="quiz">quiz</mat-icon>
        <mat-icon matTooltip="edit_square">edit_square</mat-icon>
        <mat-icon matTooltip="privacy_tip">privacy_tip</mat-icon>
        <mat-icon matTooltip="help_center">help_center</mat-icon>
        <mat-icon matTooltip="feedback">feedback</mat-icon>
    </div>
    }
    <mat-divider></mat-divider>
</div>

<!-- Guide for cards -->
<div class="block">
    <button
        mat-raised-button
        (click)="cardsVisible.set(!cardsVisible())"
    >
        @if (cardsVisible()) {
        <mat-icon>expand_less</mat-icon>
        } @else {
        <mat-icon>expand_more</mat-icon>
        }
        Karten
    </button>
    @if (cardsVisible()) {
    <div class="blockcontent">
        <mat-card>
            <mat-card-header>
                <mat-card-title>{{ cardHeadline }}</mat-card-title>
            </mat-card-header>
            <mat-card-subtitle>
                <hr />
            </mat-card-subtitle>
            <mat-card-content>
                {{ cardBody }}
            </mat-card-content>
        </mat-card>
    </div>
    }
    <mat-divider></mat-divider>
</div>

<!-- Guide for inputfields -->
<div class="block">
    <button
        mat-raised-button
        (click)="fieldsVisible.set(!fieldsVisible())"
    >
        @if (fieldsVisible()) {
        <mat-icon>expand_less</mat-icon>
        } @else {
        <mat-icon>expand_more</mat-icon>
        }
        Felder
    </button>
    @if (fieldsVisible()) {
    <div class="blockcontent">
        <!-- Combobox -->
        <mat-form-field>
            <mat-label>Combobox</mat-label>
            <mat-select (valueChange)="onComboboxChangeEvent($event)">
                <mat-option [value]="">---</mat-option>
                @for (comboBoxValue of comboBoxValues; track comboBoxValue) {
                <mat-option [value]="comboBoxValue">{{ comboBoxValue }}</mat-option>
                }
            </mat-select>
        </mat-form-field>

        <!-- Input Field -->
        <mat-form-field appearance="outline">
            <mat-label>Input Feld</mat-label>
            <form
                [formGroup]="userForm"
                autocomplete="off"
                novalidate
            >
                <input
                    matInput
                    formControlName="input"
                />
            </form>
            @if (userForm.get("input")?.hasError("required")) {
            <mat-error>Input ist erforderlich</mat-error>
            }
        </mat-form-field>

        <!-- Checkbox -->
        <label>
            <input type="checkbox" />
            Checkbox
        </label>
    </div>
    }
    <mat-divider></mat-divider>
</div>

<!-- Guide for buttons -->
<div class="block">
    <button
        mat-raised-button
        (click)="buttonsVisible.set(!buttonsVisible())"
    >
        @if (buttonsVisible()) {
        <mat-icon>expand_less</mat-icon>
        } @else {
        <mat-icon>expand_more</mat-icon>
        }
        Buttons
    </button>
    @if (buttonsVisible()) {
    <div class="blockcontent">
        <!-- Cancelbutton -->
        <button
            mat-button
            (click)="buttonclick()"
        >Abbrechen</button>

        <!-- Savebutton -->
        <button
            mat-raised-button
            (click)="buttonclick()"
        >Speichern</button>

        <!-- "Add entries"-button -->
        <button
            mat-stroked-button
            color="primary"
            (click)="buttonclick()"
        ><mat-icon>add</mat-icon> Datensätze anlegen</button>

        <button
            mat-flat-button
            color="primary"
            (click)="buttonclick()"
        ><mat-icon>remove_red_eye</mat-icon> VORSCHAU</button>

        <!-- Iconbutton. fill in any icon you want -->
        Ein Iconbutton:
        <button
            mat-icon-button
            (click)="buttonclick()"
        >
            <mat-icon>edit</mat-icon>
        </button>
    </div>
    }
    <mat-divider></mat-divider>
</div>

<!-- Guide for table -->
<!-- For this styleguide the Editor data is used as dummy data. -->
<div class="block">
    <button
        mat-raised-button
        (click)="tableVisible.set(!tableVisible())"
    >
        @if (tableVisible()) {
        <mat-icon>expand_less</mat-icon>
        } @else {
        <mat-icon>expand_more</mat-icon>
        }
        Tabelle
    </button>
    @if (tableVisible()) {
    <div class="blockcontent">
        <div class="main-table">
            <div class="table-container mat-elevation-z4">
                <table
                    mat-table
                    [dataSource]="dataSource"
                    matSort
                    (matSortChange)="announceSortChange($event)"
                >
                    <ng-container matColumnDef="edit-actions">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                        >Aktionen</th>
                        <td
                            mat-cell
                            *matCellDef="let editor"
                            class="action-column no-wrap"
                        >
                            <button
                                mat-icon-button
                                color="primary"
                                aria-label="Edit"
                                (click)="openDialog()"
                            >
                                <!-- Please refer to the dialog section in the styleguide for further information.
                       The click-event ist just there to show that it would normally be there -->
                                <mat-icon>edit</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="id">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                        >ID</th>
                        <td
                            mat-cell
                            *matCellDef="let editor"
                        >{{ editor.id }}</td>
                    </ng-container>

                    <ng-container matColumnDef="email">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                        >eMail</th>
                        <td
                            mat-cell
                            *matCellDef="let editor"
                        >{{ editor.email }}</td>
                    </ng-container>

                    <ng-container matColumnDef="role">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                        >Rolle</th>
                        <td
                            mat-cell
                            *matCellDef="let editor"
                            class="no-wrap"
                        >{{ getEditorRoleViewValue(editor.role) }}</td>
                    </ng-container>

                    <ng-container matColumnDef="updated">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                        >Updated</th>
                        <td
                            mat-cell
                            *matCellDef="let editor"
                        >{{ editor.updated | date }}</td>
                    </ng-container>

                    <ng-container matColumnDef="array">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                        >Array mit Badges</th>
                        <td
                            mat-cell
                            *matCellDef="let editor"
                        >
                            @for (value of getArray(); track value) {
                            <span class="badge badge-dark me-1">
                                {{ value }}
                            </span>
                            }
                        </td>
                    </ng-container>

                    <tr
                        mat-header-row
                        *matHeaderRowDef="displayedColumns; sticky: true"
                    ></tr>
                    <tr
                        mat-row
                        *matRowDef="let row; columns: displayedColumns"
                    ></tr>
                </table>
                <pixl-main-pagination [pageChangeCallback]="paginationChanged"></pixl-main-pagination>
            </div>
        </div>
    </div>
    }
    <mat-divider></mat-divider>
</div>


<!-- Guide for table loading spinner -->
<!-- For this styleguide the Editor data is used as dummy data. -->
<div class="block">
    <button
        mat-raised-button
        (click)="tableSpinnerVisible.set(!tableSpinnerVisible())"
    >
        @if (tableSpinnerVisible()) {
        <mat-icon>expand_less</mat-icon>
        } @else {
        <mat-icon>expand_more</mat-icon>
        }
        Tabellen-Lade-Spinner
    </button>
    @if (tableSpinnerVisible()) {
    <div class="blockcontent">
        <div class="main-table">
            <pixl-table-loading-spinner [name]="'<name>'" />
        </div>
    </div>
    }
    <mat-divider></mat-divider>
</div>

<!-- Guide for dialog on buttonclick  -->
<div class="block">
    <button
        mat-raised-button
        (click)="dialogVisible.set(!dialogVisible())"
    >
        @if (dialogVisible()) {
        <mat-icon>expand_less</mat-icon>
        } @else {
        <mat-icon>expand_more</mat-icon>
        }
        Modal-Fenster
    </button>
    @if (dialogVisible()) {
    <div class="blockcontent">
        <!-- The important thing here is the reference to the dialog component via the function -->
        <button
            mat-stroked-button
            (click)="openDialog()"
            color="primary"
        >Dialog öffnen</button>
    </div>
    }
    <mat-divider></mat-divider>
</div>